import { render, staticRenderFns } from "./PnlCreatePage.vue?vue&type=template&id=5295e0e0"
import script from "./PnlCreatePage.vue?vue&type=script&lang=ts"
export * from "./PnlCreatePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports